import React from 'react'
import Container from '../templates/app/Container'
import CreateMoment from '../templates/createMoment/CreateMoment'
import MomentCard from '../templates/momentCard/MomentCard'

export default ({ userId }) => (
  <Container>
    <CreateMoment userId={userId}>
      {({ moment, onSaveMoment }) => (
        <MomentCard moment={moment} handleSave={onSaveMoment} />
      )}
    </CreateMoment>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/pages/CreateMomentPage.js